import DateUtil from "./Date";

export function jsonToForm(json) {
  return json;
}

export function filterByClient(chips, search) {
  let filter = chips;
  let enabled = false;
  if(typeof search !== "undefined") {
    if(typeof search.client !== "undefined" && search.client.id !== "") {
      enabled = true;
      filter = filter.filter((p) => typeof p.client !== "undefined" && p.client.id === search.client.id);
    }
    if(typeof search.active !== "undefined" && search.active !== -1) {
      enabled = true;
      filter = filter.filter((p) => typeof p.active !== "undefined" && p.active === search.active);
    }
  }
  return {
    enabled,
    results: filter
  };
}

export function filterByClientAndWord(chips, search) {
  let filter = chips;
  let enabled = false;
  if(typeof search !== "undefined") {
    if(typeof search.client !== "undefined" && search.client.id !== "") {
      enabled = true;
      filter = filter.filter((p) => typeof p.client !== "undefined" && p.client.id === search.client.id);
    }
    if(typeof search.word !== "undefined" && search.word !== "") {
      enabled = true;
      filter = filter.filter(
        (p) =>
          (p.serial && p.serial.toLowerCase().indexOf(search.word.toLowerCase()) !== -1) ||
          (p.line && p.line.toLowerCase().indexOf(search.word.toLowerCase()) !== -1)
      );
    }
    if(typeof search.active !== "undefined" && search.active !== -1) {
      enabled = true;
      filter = filter.filter((p) => typeof p.active !== "undefined" && p.active === search.active);
    }
  }
  return {
    enabled,
    results: filter
  };
}

export function sortChips(chips, asc = true) {
  if(asc) {
    return chips.sort((a, b) => {
      const nameA = a.serial;
      const nameB = b.serial;
      if(nameA > nameB) return 1;
      else if(nameA < nameB) return -1;
      return 0;
    });
  }
  return chips.sort((a, b) => {
    const nameA = a.serial;
    const nameB = b.serial;
    if(nameA > nameB) return -1;
    else if(nameA < nameB) return 1;
    return 0;
  });
}
